import { TypedDocumentNode, gql } from "@apollo/client";

interface Country {
  country: {
    id: string;
    name: string;
    code_slug: string;
    cities: { id: string; name: string; name_slug: string }[];
  };
}

interface CountryParams {
  ID: number;
}

export const GET_COUNTRY_BY_ID: TypedDocumentNode<Country, CountryParams> = gql`
  query GetCountryById($ID: ID!) {
    country(id: $ID) {
      id
      name
      code_slug
      cities {
        id
        name
        name_slug
      }
    }
  }
`;
